<template>
  <div class="">

    <div class="">
      <span class="single-feature-label-width">{{ feature.name }}</span>
      <input type="text" @focusin="featureOptionSuggestion('in')" class="form-control d-inline w-auto mx-1"
             v-model="searchWords">
    </div>


    <div :class="`border shadow d-none feature-attribute-list feature-attribute-list-${hashGenerator} p-3`">
      <p class="feature-attribute-list-item" v-for="item in featureAttributesSearch" @click="selectItem(item)">
        {{ item.value }}</p>
    </div>

  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "SingleFeature",
  props: {
    feature: {
      default: []
    },
    featureAttributes: {
      default: []
    },
  },
  data() {
    return {
      searchWords: '',
    }
  },
  computed: {
    hashGenerator() {
      return generateHash()
    },
    featureAttributesSearch() {
      if (this.searchWords.length === 0) {
        return []
      }
      return this.featureAttributes.filter(item => {
        return item.value.indexOf(this.searchWords) > -1
      })
    }
  },
  methods: {
    selectItem(item) {
      this.searchWords = item.value
      this.featureOptionSuggestion('out')
      this.$emit('selectedItem', item)
    },
    featureOptionSuggestion(mode = 'in') {
      let element = document.querySelector(`.feature-attribute-list-${this.hashGenerator}`);
      if (mode == 'in') {
        element.classList.remove('d-none')
      } else {
        element.classList.add('d-none')
      }
    }
  }
}
</script>

<style scoped>
.feature-attribute-list {
  height: 150px;
  overflow: auto;
  position: absolute;
  width: auto;
  background: white;
  z-index: 2;
  margin: auto;
}

.feature-attribute-list-item {
  cursor: pointer;
}

.single-feature-label-width {
  width: 40px;
  display: inline-grid
}

</style>